import { API_BASE_URL } from "@/api/api.config";
import useLazyRestQuery from "@/remoteState/useLazyRestQuery";

const useLazyAnnotationsGet = (articleHeaderId) => {
  const params = { article_id: articleHeaderId };

  const queryString = new URLSearchParams(params).toString();

  const resource = `${API_BASE_URL}/api/v2/annotation/?${queryString}`;

  return useLazyRestQuery(resource);
};

export default useLazyAnnotationsGet;
